<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-chip v-if="small !== ''" v-on="on" outlined color="primary">
        <v-avatar left>
          <v-icon>{{ user.isadmin ? 'supervised_user_circle' : 'account_circle' }}</v-icon>
        </v-avatar>
        <span>
        {{ user.username }}
        </span>
      </v-chip>

      <span v-on="on" v-if="small == ''">
        <a :href="'mailto:' + user.email">
          <b>{{ user.username }}</b>
        </a>
      </span>
    </template>
    <span>
      {{ user.name }} {{ user.surname }}
      <br />
      {{ user.email }}
    </span>
    <span v-if="user.isadmin">
      <br />
      <b>Administrator</b>
    </span>
  </v-tooltip>
</template>

<script>
export default {
  props: ["user", "small"],
  data() {
    return {};
  }
};
</script>

<style>

</style>

